// API Configuration

// Get API base URLs from environment variables or use defaults
export const API_BASE_URL = {
  AUTH: import.meta.env.VITE_AUTH_API_BASE_URL || 'http://localhost:8000/api/v1',
  PROFILE: import.meta.env.VITE_PROFILE_API_BASE_URL || 'http://localhost:8080/api/v1',
  CAMPAIGN: import.meta.env.VITE_CAMPAIGN_API_BASE_URL || 'http://localhost:8001/api/v1',
} as const;

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    REGISTER_SMS: '/auth/register/sms',
    REGISTER_EMAIL: '/auth/register/email',
    SEND_OTP_SMS: '/auth/otp/send/sms',
    SEND_OTP_EMAIL: '/auth/otp/send/email',
    VERIFY_OTP: '/auth/verify-registration',
    LOGIN: '/auth/login-password',
    LOGOUT: '/auth/logout',
    CHANGE_PASSWORD: '/auth/change-password',
    GOOGLE_AUTH: '/auth/google',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
  },
  PROFILE: {
    CREATE: '/profiles',
    GET: '/profiles/me',
    UPDATE: '/profiles',
    UPLOAD_URL: '/profile-image/upload-url',
    UPDATE_IMAGE: '/profile-image',
  },
  CAMPAIGN: {
    CREATE: '/campaigns',
    LIST: '/campaigns',
    GET: '/campaigns', // GET /campaigns/:id
    UPDATE: '/campaigns', // PUT /campaigns/:id
    DELETE: '/campaigns', // DELETE /campaigns/:id
    COMPLETE: '/campaigns/delete-complete', // DELETE /campaigns/delete-complete/:id
  },
  SURVEY: {
    CREATE: '/surveys',
    LIST: '/surveys',
    GET: '/surveys', // GET /surveys/:id
    UPDATE: '/surveys', // PUT /surveys/:id
    DELETE: '/surveys', // DELETE /surveys/:id
    GENERATE_QUESTIONS: '/surveys/generate-questions',
  },
  CONTACT: {
    UPLOAD: '/contacts/campaigns', // POST /contacts/campaigns/:campaign_id/upload
    LIST: '/contacts/campaigns', // GET /contacts/campaigns/:campaign_id
    PARTICIPANTS: '/contacts/campaigns', // GET /contacts/campaigns/:campaign_id/contacts
    STATS: '/contacts/campaigns', // GET /contacts/campaigns/:campaign_id/stats
    GET: '/contacts', // GET /contacts/:id
    UPDATE: '/contacts', // PUT /contacts/:id
    DELETE: '/contacts', // DELETE /contacts/:id
    RESPONSES: '/contacts/responses', // GET /contacts/responses?limit=100&offset=0&survey_completed=true
    REVIEWS_MONTHLY: '/contacts/reviews/monthly', // GET /contacts/reviews/monthly
  },
  TICKET: {
    CREATE: '/tickets',
    LIST: '/tickets',
    GET: '/tickets', // GET /tickets/:id
    GET_BY_NUMBER: '/tickets/number', // GET /tickets/number/:number
    UPDATE: '/tickets', // PUT /tickets/:id
    CLOSE: '/tickets', // POST /tickets/:id/close
    DELETE: '/tickets', // DELETE /tickets/:id
    ADD_MESSAGE: '/tickets', // POST /tickets/:id/messages
    GET_MESSAGES: '/tickets', // GET /tickets/:id/messages
  },
  NOTIFICATION: {
    GET_PREFERENCES: '/notifications/preferences',
    UPDATE_PREFERENCES: '/notifications/preferences',
  },
  TEMPLATE: {
    GET_ALL: '/survey-templates',
    GET_SMS: '/survey-templates/sms',
    GET_EMAIL: '/survey-templates/email',
    CREATE: '/survey-templates',
    PREVIEW: '/survey-templates/preview',
    DELETE: '/survey-templates', // DELETE /survey-templates/:type
  },
} as const;

